import React, { useState } from "react";
import "./DeleteUserForm.css";
import { deleteUser } from "../../api/api";

import loader from "../../assets/images/loader.gif";

export default function DeleteUserForm(props) {
  const openApp = () => {
    window.location = "com.searates-connect://";
  };

  const [loading, setLoading] = useState(false);
  const [responseMessage, setResponseMessage] = useState(false);
  const [resetStatus, setResetStatus] = useState(false);
  const [errorEmail, setErrorEmail] = useState(false);
  const [errorPass, setErrorPass] = useState(false);

  const [emailErrorText, setEmailErrorText] = useState("");
  const [passErrorText, setPassErrorText] = useState("");

  const [email, setEmail] = useState("");

  const [password, setPassword] = useState("");

  const submitPass = () => {
    if (!errorPass && !errorEmail) {
      setLoading(true);
      let payload = {
        email: email,
        password: password,
      };
      if (email == "" || password == "") {
        setLoading(false);

        checkEmail(email);
        checkPassword(password);
      } else {
        deleteUser(payload)
          .then((res) => {
            if (res.data.code === 200) {
              setResetStatus(true);
            } else {
              setResetStatus(false);
            }
            setResponseMessage(res.data.message);
            setLoading(false);
          })
          .catch(function(error) {
            if (error.response) {
              // The request was made and the server responded with a status code
              // that falls out of the range of 2xx

              setResponseMessage(error.response.data.message);
              setResetStatus(false);
              setLoading(false);
            }
          });
      }
    }
  };

  const checkPassword = (value) => {
    if (value == "") {
      setErrorPass(true);
      setPassErrorText("Password is required");
    } else {
      setErrorPass(false);
    }
    setPassword(value);
  };

  const checkEmail = (value) => {
    if (value == "") {
      setErrorEmail(true);
      setEmailErrorText("Email is required");
    } else {
      setErrorEmail(false);
    }
    setEmail(value);
  };

  if (loading)
    return (
      <div className="align-center align-center-pass-reset">
        <img src={loader} alt="loading..." className="loader" />
      </div>
    );
  else
    return (
      <div className="align-center align-center-pass-reset">
        <div className="verification-box">
          <div className={{}} />
          <div className="delete-user-box">
            {resetStatus ? (
              <>
                <h1>{responseMessage}</h1>
              </>
            ) : (
              <>
                <h1>Enter Detail For Delete Account</h1>
                <h3>{responseMessage}</h3>
                <div>
                  <input
                    type={"text"}
                    placeholder="Email"
                    className="input"
                    onChange={(e) => checkEmail(e.target.value)}
                  />

                  <p className="error-text">
                    {errorEmail ? emailErrorText : " "}
                  </p>
                </div>

                <div>
                  <input
                    type={"password"}
                    placeholder="Password"
                    className="input"
                    onChange={(e) => checkPassword(e.target.value)}
                  />

                  <p className="error-text">
                    {errorPass ? passErrorText : " "}
                  </p>
                </div>
                <button className="button" onClick={submitPass}>
                  SUBMIT
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    );
}
